import FAQArticlePage from "./FAQArticle";

const data = {
  title: "Cancelling my subscription",
  category: "Subscription Management",
  content: `You can cancel your subscription at any time by reaching out to our support team. Simply send us an email, and we'll help you with the cancellation process as quickly as possible.

No forms, no complicated steps — we'll handle everything for you.

What to expect after cancellation:
- Your subscription will remain active until the end of the current billing period
- You will not be charged again after cancellation
- You will receive a confirmation email once the cancellation is processed
- If you change your mind, you can reactivate your subscription at any time

For immediate assistance, please contact our support team directly.

Email: support@novavertextech.com
Phone: +44 7520 663474`,
};

export default function SMQ1Page() {
  return <FAQArticlePage data={data} />;
}